import React from 'react';
import Header from './Header';
import '../../css/Admin.css';

const UserLayout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="user-layout">
        <div className="container py-5">
          {children}
        </div>
      </div>
    </>
  );
};

export default UserLayout;